/**
 * /account-security — the signed-in platform admin's own two-step sign-in and
 * sessions.
 */
import { createFileRoute } from "@tanstack/react-router";
import { AccountSecurityScreen } from "../features/account-security/AccountSecurityScreen";

export const Route = createFileRoute("/_auth/account-security")({
  staticData: { breadcrumb: { labelKey: "nav.account_security" } },
  component: AccountSecurityScreen,
});
